import React from "react";
import { observer, useLocalStore } from "mobx-react";
import { EOCAsyncSelect } from "../input/EOCAsyncSelect";
import { Grid } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import apiCall from "../../scripts/apiCall";

const SAPEmployeePicker = ({
  title,
  value,
  required,
  updatefunc,
  multi = false,
  isCreatable = false,
}) => {
  const { instance, accounts } = useMsal();
  const getData = (input) =>
    new Promise((resolve) => {
      let fetchOptions = {
        method: "POST",
        credentials: "same-origin",

        body: JSON.stringify({
          proj: "Z_GW_PROSPECT_SRV",
          funct: "EmployeeSet",
          parameters: `$format=json`,
        }),
      };
      var sys = window.localStorage.getItem("QUOTEsys");
      let url = `SAPOData${sys}`;

      return apiCall(
        url,
        fetchOptions,
        (json) => {
          if (input === "" && value === null) {
            const rep = json.find((value) => {
              return (
                value.FirstName.normalize("NFD").replace(
                  /[\u0300-\u036f]/g,
                  ""
                ) +
                  " " +
                  value.LastName.normalize("NFD").replace(
                    /[\u0300-\u036f]/g,
                    ""
                  ) ===
                accounts[0].name
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
            });
            if (rep) {
              console.log(rep);
              updatefunc({
                Name: rep.FirstName + " " + rep.LastName,
                Id: rep.EmployeeID,
                value: rep.EmployeeID,
                label:
                  rep.EmployeeID +
                  " " +
                  rep.FirstName +
                  " " +
                  rep.LastName +
                  " (" +
                  rep.SalesOrganizationID +
                  ")",
              });
            }
          }
          resolve(
            json.map((result) => ({
              Name: result.FirstName + " " + result.LastName,
              Id: result.EmployeeID,
              value: result.EmployeeID,
              label:
                result.EmployeeID +
                " " +
                result.FirstName +
                " " +
                result.LastName +
                " (" +
                result.SalesOrganizationID +
                ")",
            }))
          );
        },
        instance,
        accounts
      );
    });

  const lstore = useLocalStore(() => ({
    onChange(newVal, actionMeta) {
      if (newVal !== null) {
        if (multi) {
          if (isCreatable && actionMeta.action === "create-option")
            newVal.forEach((element) => {
              if (element.__isNew__) {
                element.Name = element.label;
                element.Id = "0";
              }
            });
          updatefunc(newVal);
        } else {
          if (newVal.__isNew__) {
            newVal.Name = newVal.label;
            newVal.Id = "0";
          }
          updatefunc(newVal);
        }
      } else {
        updatefunc(null);
      }
    },
  }));

  return (
    <Grid container spacing={0} direction="column">
      <Grid item xs>
        <label>
          {title}
          {required && " *"}
        </label>
      </Grid>
      <Grid item xs>
        <EOCAsyncSelect
          cy={title}
          isMulti={multi}
          loadOptions={getData}
          value={value}
          updateF={lstore.onChange}
          clearAble={isCreatable}
          isCreatable={isCreatable}
          isSearchable={false}
          defaultOptions
        />
      </Grid>
    </Grid>
  );
};

export default observer(SAPEmployeePicker);
